import * as Yup from 'yup';
import i18n from 'i18n-js';

const createYupSchema = (schema, config) => {
  const { name, validation_type } = config;

  if (!Yup[validation_type]) {
    return schema;
  }

  let validator;

  if (config.validation_type_message) {
    validator = Yup[validation_type](config.validation_type_message);
  } else {
    validator = Yup[validation_type]();
  }

  if (config.model) {
    schema[name] = config.model;
    return schema;
  }

  let message = i18n.t('common.required_field');

  Object.entries(config).forEach(([key]) => {
    switch (key) {
      case 'required': {
        if (config.required) {
          let msg = config.required_message || message;
          validator = validator[key](msg);
        }
        break;
      }
      case 'email': {
        validator = validator[key](i18n.t('common.invalid_email'));
        break;
      }
      default:
        break;
    }
  });
  schema[name] = validator;
  return schema;
};

const getDefaultValues = (schema) => {
  return schema.reduce((obj, item) => {
    obj[item.name] = item.default_value || '';
    return obj;
  }, {});
};

export { createYupSchema, getDefaultValues };
